import {
  SINGLE_WITH_PAGE_FOCUSED,
  SINGLE_WITH_SECTION_FOCUSED,
  SINGLE_WITH_TFM_PAGE_FOCUSED,
  SINGLE_WITH_TFM_SECTION_FOCUSED,
  MULTI_WITH_PAGE_FOCUSED,
  MULTI_WITH_SECTION_FOCUSED,
  MULTI_WITH_TFM_SECTION_FOCUSED,
  MULTI_WITH_TFM_PAGE_FOCUSED,
} from '@/constants';

export const getPageState = (isSinglePage, isMatrixPage, isSectionsSelected) => {
  if (isSinglePage && !isMatrixPage) return isSectionsSelected ? SINGLE_WITH_SECTION_FOCUSED : SINGLE_WITH_PAGE_FOCUSED;

  if (isSinglePage && isMatrixPage) return isSectionsSelected ? SINGLE_WITH_TFM_SECTION_FOCUSED : SINGLE_WITH_TFM_PAGE_FOCUSED;

  if (!isSinglePage && !isMatrixPage) return isSectionsSelected ? MULTI_WITH_SECTION_FOCUSED : MULTI_WITH_PAGE_FOCUSED;

  if (!isSinglePage && isMatrixPage) return isSectionsSelected ? MULTI_WITH_TFM_SECTION_FOCUSED : MULTI_WITH_TFM_PAGE_FOCUSED;
};

export const getPageDeleteOptions = (
  state,
  selectedSectionsQuantity,
  { deletePage, deleteSection, deleteAllSections, deleteWholeContent, deleteSectionContent, deleteSelectedContents, deleteSelectedSections },
) => {
    switch (state) {
      case SINGLE_WITH_SECTION_FOCUSED: {
        return ([
          {
            title: 'app.editor.modal.deleteContent',
            defaultMessage: 'Delete content',
            action: deleteSectionContent,
          },
          {
            title: 'app.editor.modal.deleteSelectedElement',
            defaultMessage: 'Delete selected element',
            action: deleteSection,
          },
        ]);
      }
      case SINGLE_WITH_TFM_SECTION_FOCUSED: {
        return ([
          {
            title: 'app.editor.modal.deleteContent',
            defaultMessage: 'Delete content',
            action: selectedSectionsQuantity > 1 ? deleteSelectedContents : deleteSectionContent,
          },
          {
            title: 'app.editor.modal.deleteSelectedElement',
            defaultMessage: 'Delete selected element',
            action: selectedSectionsQuantity > 1 ? deleteSelectedSections : deleteSection,
          },
        ]);
      }
      case SINGLE_WITH_PAGE_FOCUSED: {
        return ([
          {
            title: 'app.editor.modal.deleteAllSections',
            defaultMessage: 'Delete all elements',
            action: deleteAllSections,
          },
          {
            title: 'app.editor.modal.deleteWholeContent',
            defaultMessage: 'Delete whole content',
            action: deleteWholeContent,
          },
        ]);
      }
      case SINGLE_WITH_TFM_PAGE_FOCUSED: {
        return ([
          {
            title: 'app.editor.modal.deleteWholeMatrix',
            defaultMessage: 'Delete whole matrix',
            action: deleteAllSections,
          },
          {
            title: 'app.editor.modal.deleteWholeContent',
            defaultMessage: 'Delete whole content',
            action: deleteWholeContent,
          },
        ]);
      }
      case MULTI_WITH_SECTION_FOCUSED: {
        return ([
          {
            title: 'app.editor.modal.deleteContent',
            defaultMessage: 'Delete content',
            action: selectedSectionsQuantity > 1 ? deleteSelectedContents : deleteSectionContent,
          },
          {
            title: 'app.editor.modal.deleteSelectedElement',
            defaultMessage: 'Delete selected element',
            action: selectedSectionsQuantity > 1 ? deleteSelectedSections : deleteSection,
          },
        ]);
      }
      case MULTI_WITH_PAGE_FOCUSED: {
        return ([
          {
            title: 'app.editor.modal.deletePage',
            defaultMessage: 'Delete page',
            action: deletePage,
          },
          {
            title: 'app.editor.modal.deleteAllSections',
            defaultMessage: 'Delete all elements',
            action: deleteAllSections,
          },
          {
            title: 'app.editor.modal.deleteWholeContent',
            defaultMessage: 'Delete whole content',
            action: deleteWholeContent,
          },
        ]);
      }
      case MULTI_WITH_TFM_SECTION_FOCUSED: {
        return ([
          {
            title: 'app.editor.modal.deleteContent',
            defaultMessage: 'Delete content',
            action: selectedSectionsQuantity > 1 ? deleteSelectedContents : deleteSectionContent,
          },
          {
            title: 'app.editor.modal.deleteSelectedElement',
            defaultMessage: 'Delete selected element',
            action: selectedSectionsQuantity > 1 ? deleteSelectedSections : deleteSection,
          },
        ]);
      }
      case MULTI_WITH_TFM_PAGE_FOCUSED: {
        return ([
          {
            title: 'app.editor.modal.deletePage',
            defaultMessage: 'Delete page',
            action: deletePage,
          },
          {
            title: 'app.editor.modal.deleteWholeMatrix',
            defaultMessage: 'Delete whole matrix',
            action: deleteAllSections,
          },
          {
            title: 'app.editor.modal.deleteWholeContent',
            defaultMessage: 'Delete whole content',
            action: deleteWholeContent,
          },
        ]);
      }
      default: {
        return ([]);
      }
    }
}
